import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const SocialMedia = () => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
            }}
        >
            <SocialIcon
                title="+91-9000316721"
                href="tel:+919000316721"
                icon={<PhoneIcon />}
                defaultColor="#9ca3af"
                hoverColor="#34b7f1"
            />
            <SocialIcon
                title="info@vensyx.com"
                href="mailto:info@vensyx.com?subject=Enquiry"
                icon={<EmailIcon />}
                defaultColor="#9ca3af"
                hoverColor="#d44638"
            />
            <SocialIcon
                title="LinkedIn / vensyx"
                href="https://www.linkedin.com/company/vensyx-data-solutions-pvt-ltd-/about/"
                icon={<LinkedInIcon />}
                defaultColor="#9ca3af"
                hoverColor="#0A66C2"
            />
            <SocialIcon
                title="Twitter / @vensyx2014"
                href="https://twitter.com/vensyx2014"
                icon={<TwitterIcon />}
                defaultColor="#9ca3af"
                hoverColor="#1DA1F2"
            />
            <SocialIcon
                title="Chat on WhatsApp"
                href="https://wa.me/919000316721"
                icon={<WhatsAppIcon />}
                defaultColor="#9ca3af"
                hoverColor="#25D366"
            />
        </Box>
    );
};

const SocialIcon = ({ title, href, icon, defaultColor, hoverColor }) => (
    <Tooltip title={title} placement="bottom" arrow>
        <IconButton
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
                color: defaultColor,
                transition: "color 0.3s ease",
                "&:hover": {
                    color: hoverColor,
                },
            }}
        >
            {icon}
        </IconButton>
    </Tooltip>
);

export default SocialMedia;
